import React, { useState, useContext, useEffect } from 'react';
import { Button, Paper, Typography, TableContainer, TableBody, TableCell, TableHead, TableRow, Table, IconButton, Box } from '@mui/material';
import { isEmpty } from 'lodash';
import { Stack } from '@mui/system';
import AddRoundedIcon from '@mui/icons-material/AddRounded';
import VisibilityRoundedIcon from '@mui/icons-material/VisibilityRounded';
import { getToken } from '../../../api/Account';
import { DataContext } from '../../../context/DataContext';

import { getRuta, isAccess, simpleMessage } from '../../../helpers/Helpers';

import NoData from '../../../components/NoData';
import { PaginationComponent } from '../../../components/PaginationComponent';
import { useNavigate } from 'react-router-dom';
import StatusChip from '../../../components/ui/StatusChip';
import { monoFont } from '../../../theme';

import { getCreditsByClientAsync } from '../../../api/Clients';
import moment from 'moment/moment';

const money = (n) => new Intl.NumberFormat('es-NI', { style: 'currency', currency: 'NIO' }).format(n);

const ClientCredits = ({ id }) => {
	const token = getToken();
	let ruta = getRuta();
	let navigate = useNavigate();
	const [creditList, setCreditList] = useState([]);

	const { setIsLoading, setIsUnautorized, access } = useContext(DataContext);

	const [searchTerm] = useState('');

	const withSearch = creditList.filter((val) => {
		if (searchTerm === '') {
			return val;
		} else if (val.id.toString().includes(searchTerm)) {
			return val;
		}
		return false;
	});

	useEffect(() => {
		(async () => {
			setIsLoading(true);
			const result = await getCreditsByClientAsync(token, id);
			if (!result.statusResponse) {
				setIsLoading(false);
				if (result.error === 'Unauthorized') {
					setIsUnautorized(true);
					return;
				}
				simpleMessage(result.error, 'error');
				return;
			}
			setIsLoading(false);
			setCreditList(result.data.result);
		})();
	}, []);

	const [currentPage, setCurrentPage] = useState(1);
	const [itemsperPage] = useState(10);
	const indexLast = currentPage * itemsperPage;
	const indexFirst = indexLast - itemsperPage;
	const currentItem = withSearch.slice(indexFirst, indexLast);
	const paginate = (pageNumber) => setCurrentPage(pageNumber);

	return (
		<div>
			<Paper sx={{ overflow: 'hidden' }}>
				<Box
					sx={{
						display: 'flex',
						alignItems: 'center',
						justifyContent: 'space-between',
						padding: '16px 20px',
						borderBottom: '1px solid',
						borderColor: 'divider',
						flexWrap: 'wrap',
						gap: '10px'
					}}
				>
					<Typography sx={{ fontSize: 15, fontWeight: 600 }}>Créditos del cliente</Typography>

					{isAccess(access, 'CREDITS CREATE') ? (
						<Button onClick={() => navigate(`${ruta}/credit/add/${id}`)} variant="contained" color="primary" size="small" startIcon={<AddRoundedIcon sx={{ fontSize: 17 }} />}>
							Agregar
						</Button>
					) : null}
				</Box>

				{isEmpty(currentItem) ? (
					<NoData />
				) : (
					<Stack spacing={0}>
						<TableContainer sx={{ overflowX: 'auto' }}>
							<Table size="small" sx={{ minWidth: 720 }}>
								<TableHead>
									<TableRow>
										<TableCell>No.</TableCell>
										<TableCell align="right">Desembolso</TableCell>
										<TableCell align="right">Saldo</TableCell>
										<TableCell>F. Entrega</TableCell>
										<TableCell align="center">Estadística</TableCell>
										<TableCell align="center">Estado</TableCell>
										{isAccess(access, 'CREDITS VER') ? <TableCell align="center">Ver</TableCell> : null}
									</TableRow>
								</TableHead>
								<TableBody>
									{currentItem.map((row) => (
										<TableRow key={row.id}>
											<TableCell sx={{ fontFamily: monoFont, color: 'text.disabled' }}>#{row.id}</TableCell>
											<TableCell align="right" sx={{ fontFamily: monoFont }}>
												{money(row.montoEntregado)}
											</TableCell>
											<TableCell align="right" sx={{ fontFamily: monoFont, fontWeight: 600 }}>
												{money(row.cuotaPagar)}
											</TableCell>
											<TableCell sx={{ fontFamily: monoFont, fontSize: 12.5 }}>{moment(row.fechaVencimiento).format('L')}</TableCell>
											<TableCell align="center" sx={{ fontFamily: monoFont }}>
												{row.promedio.toFixed(2)}
											</TableCell>
											<TableCell align="center">
												<StatusChip label={row.isCanceled ? 'Cancelado' : 'Activo'} tone={row.isCanceled ? 'neutral' : 'success'} />
											</TableCell>
											{isAccess(access, 'CREDITS VER') ? (
												<TableCell align="center">
													<IconButton size="small" onClick={() => navigate(`${ruta}/credit/${row.id}`)}>
														<VisibilityRoundedIcon sx={{ fontSize: 17 }} />
													</IconButton>
												</TableCell>
											) : null}
										</TableRow>
									))}
								</TableBody>
							</Table>
						</TableContainer>
						<Box sx={{ padding: '10px 20px 14px' }}>
							<PaginationComponent data={withSearch} paginate={paginate} itemsperPage={itemsperPage} />
						</Box>
					</Stack>
				)}
			</Paper>
		</div>
	);
};

export default ClientCredits;
